//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

module.exports = {
    accessModifiers: require('./accessModifiers'),
    actionElements: require('./actionElements'),
    blocklyViews: require('./blocklyViews'),
    dataViews: require('./dataViews'),
    detailPanes: require('./detailPanes'),
    dialogs: require('./dialogs'),
    documentations: require('./documentations'),
    filters: require('./filters'),
    formButtons: require('./formButtons'),
    formElements: require('./formElements'),
    forms: require('./forms'),
    graphs: require('./graphs'),
    layouts: require('./layouts'),
    listColumns: require('./listColumns'),
    lists: require('./lists'),
    menuSelections: require('./menuSelections'),
    menus: require('./menus'),
    navHeadings: require('./navHeadings'),
    pages: require('./pages'),
    rangeTypes: require('./rangeTypes'),
    searchElements: require('./searchElements'),
    searchPanes: require('./searchPanes'),
    transforms: require('./transforms'),
    workflowCriteriaElements: require('./workflowCriteriaElements'),
    workflowLogics: require('./workflowLogics'),
    workflowPanes: require('./workflowPanes'),
};


